/**
 * Axis-aligned box geometry — pure, framework-free, unit-tested.
 * Used for hitboxes and hurtboxes. Coordinates are world-space, top-left origin.
 */
export interface Box {
  x: number;
  y: number;
  w: number;
  h: number;
}

/** Build a Box centred on (cx, cy). */
export function boxFromCenter(cx: number, cy: number, w: number, h: number): Box {
  return { x: cx - w / 2, y: cy - h / 2, w, h };
}

/** Standard AABB overlap test (touching edges do NOT count as overlap). */
export function aabbOverlap(a: Box, b: Box): boolean {
  return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
}

/** Centre point of a box — handy for knockback direction. */
export function centerX(box: Box): number {
  return box.x + box.w / 2;
}
